import React from 'react';
import { Typography, Layout, Divider, Table } from 'antd';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const TermsUA = () => {
  // Data for the SLA Incidents Table (Source 129-144)
  const slaColumns = [
    { title: 'Рівень', dataIndex: 'level', key: 'level' },
    { title: 'Опис', dataIndex: 'desc', key: 'desc' },
    { title: 'Термін відповіді', dataIndex: 'response', key: 'response' },
    { title: 'Мета вирішення', dataIndex: 'resolution', key: 'resolution' },
  ];

  const slaData = [
    { key: '1', level: 'Критичний (P1)', desc: 'Повне припинення послуги трансляції', response: '4 робочі години', resolution: '24 години' },
    { key: '2', level: 'Серйозний (P2)', desc: 'Порушення роботи без повного припинення', response: '1 робочий день', resolution: '3 робочі дні' },
    { key: '3', level: 'Незначний (P3)', desc: 'Неблокуюча несправність', response: '2 робочі дні', resolution: 'Заплановане виправлення' },
  ];

  // Data for the Privacy Policy Table (Source 215-228)
  const privacyColumns = [
    { title: 'Ціль', dataIndex: 'goal', key: 'goal' },
    { title: 'Правова основа', dataIndex: 'basis', key: 'basis' },
  ];

  const privacyData = [
    { key: '1', goal: 'Управління обліковим записом Користувача', basis: 'Виконання договору (ст. 6.1.b GDPR)' },
    { key: '2', goal: 'Управління передплатами та виставлення рахунків', basis: 'Законне зобов\'язання' },
    { key: '3', goal: 'Технічна підтримка', basis: 'Законний інтерес' },
    { key: '4', goal: 'Безпека та запобігання зловживанням', basis: 'Законний інтерес' },
    { key: '5', goal: 'Поліпшення послуг', basis: 'Законний інтерес' },
    { key: '6', goal: 'Дотримання нормативних зобов\'язань', basis: 'Законний обов\'язок' },
  ];

  return (
    <Layout style={{ padding: '1.5em 0.75em' }}>
        <Typography>
          <Title level={3}>1. ІДЕНТИФІКАЦІЯ ВИДАВЦЯ</Title>
          <Paragraph>
            Веб-платформа musictmm.com та мобільний додаток «MusicTMM» (далі також «Платформа») видаються:
          </Paragraph>
          <Paragraph>
            ТОВ ТММ-Юкрейн , код ЄДРПОУ 40402435 (далі також «Правовласник»)
          </Paragraph>
          <Paragraph>
            Електронна пошта: Lutsenko@tmm-ukraine.com
          </Paragraph>
          <Paragraph>
            Правовласник є власником прав інтелектуальної власності, пов'язаних з Платформою.
          </Paragraph>

          <Divider />

          <Title level={3}>2. МЕТА</Title>
          <Paragraph>
            Ці Загальні умови використання (далі «Умови використання») мають на меті визначити умови, на яких надаються юридичним особам та фізичним особам-підприємцям, які мають діючі Ліцензійні договори із Правовласником (далі «Користувач») право доступу та використання Платформи.
          </Paragraph>
          <Paragraph>
            Умови використання є договором у розумінні положень Цивільного кодексу.
          </Paragraph>
          <Paragraph>
            Платформа створена виключно для юридичних осіб або фізичних осіб-підприємців, які діють в рамках своєї комерційної діяльності.
          </Paragraph>

          <Divider />

          <Title level={3}>3. ПРИЙНЯТТЯ</Title>
          <Paragraph>
            Доступ та використання Платформи передбачають беззастережне прийняття цих Умов використання.
          </Paragraph>
          <Paragraph>
            Користувач заявляє, що:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>діє в професійних цілях;</li>
            <li>має діючий ліцензійний договір із Правовласником;</li>
            <li>надає точну та актуальну інформацію.</li>
          </ul>

          <Divider />

          <Title level={3}>4. ОПИС ПОСЛУГ</Title>
          <Paragraph>
            Платформа, зокрема, дозволяє:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>публічно виконувати музичні композиції виключно в межах та на Території, встановлених у Ліцензійному договорі;</li>
            <li>отримувати доступ до готової бази плейлистів;</li>
            <li>Робити запит на індивідуальний підбір музики та формування музичних плейлистів.</li>
            <li>Відтворювати музичні плейлисти у необмеженій кількості разів.</li>
          </ul>
          <Paragraph>
            Правовласник залишає за собою право змінювати функціонал у будь-який час.
          </Paragraph>

          <Divider />

          <Title level={3}>5. ЛІЦЕНЗІЯ НА ВИКОРИСТАННЯ</Title>
          <Paragraph>
            Правовласник надає Користувачу ліцензію:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>Невиключне право на використання музичних композицій.</li>
            <li>обмежену строком дії Ліцензійного договору.</li>
          </ul>
          <Paragraph>
            Ліцензія дозволяє лише:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>доступ до Платформи;</li>
            <li>використання музичного контенту відповідно до його професійного призначення.</li>
          </ul>
          <Paragraph>
            Будь-яке використання, яке прямо не передбачено Ліцензійним договором суворо заборонені.
          </Paragraph>
          <Paragraph>
            Використання Платформи не охоплює особисті немайнові права суб’єктів авторського права і суміжних прав.
          </Paragraph>
          <Paragraph>
            Платформа також не охоплює будь-які випадки використання об’єктів авторського права і (або) суміжних прав при здійсненні артистами-виконавцями концертної і (або) гастрольної діяльності на яку продаються квитки (та/або за яку стягується плата) навіть у випадку, якщо такі заходи проводились би на Території, що передбачена ліцензійним договором.
          </Paragraph>
          <Paragraph>
            У випадку пред'явлення до Користувача претензій з боку третіх осіб, предметом яких є порушення неврегульованих цим положенням та Ліцензійного договором прав, в тому числі немайнових прав, а також майнових, які не є предметом цих правил та Ліцензійного договору, останній самостійно несе встановлену діючим законодавством України відповідальність за їх порушення.
          </Paragraph>
          <Paragraph>
            База даних Платформи захищена відповідно до Директиви 96/9/ЄС.
          </Paragraph>
          <Paragraph>
            Реєстрація на Платформі не надає жодних прав на використання Сервісу.
          </Paragraph>
          <Paragraph>
            Фактичний доступ до Сервісу залежить від підписання окремого Ліцензійного договору між Правовласником та Користувачем.
          </Paragraph>
          <Paragraph>
            Доступ до Платформи, включаючи використання наданого контенту, в жодному разі не звільняє Користувача від юридичних зобов'язань щодо сплати роялті, які можуть бути належні колективним організаціям або органам, відповідальним за збір авторських та суміжних прав, відповідно до чинного законодавства на території експлуатації.
          </Paragraph>
          <Paragraph>
            Доступ до Сервісу надається на платній основі на умовах, передбачених окремим комерційним договором, укладеним між Правовласником та Користувачем.
          </Paragraph>
          <Paragraph>
            Умови користування не визначають застосовувані тарифи.
          </Paragraph>

          <Title level={3}>6. ІНТЕЛЕКТУАЛЬНА ВЛАСНІСТЬ</Title>
          <Paragraph>
            Платформа, її алгоритми, архітектура, контент, торгові марки та бази даних залишаються виключною власністю Правовласника.
          </Paragraph>
          <Paragraph>
            Жодної передачі інтелектуальної власності на користь Користувача не здійснюється.
          </Paragraph>

          <Divider />

          <Title level={3}>7. ВМІСТ, СТВОРЕНИЙ ЗА ДОПОМОГОЮ ШТУЧНОГО ІНТЕЛЕКТУ</Title>
          <Paragraph>
            Деякі аудіоматеріали, доступні на Платформі, можуть містити елементи, створені або доповнені за допомогою технологій штучного інтелекту, зокрема синтезовані голоси, що не означає імітацію реального ідентифікованого виконавця.
          </Paragraph>
          <Paragraph>
            Правовласник дотримується вимог прозорості, передбачених європейськими нормами, що застосовуються у сфері штучного інтелекту.
          </Paragraph>

          <Divider />

          <Title level={3}>8. ПЕРСОНАЛЬНІ ДАНІ</Title>
          <Paragraph>
            Правовласник діє як відповідальний за обробку даних у значенні Регламенту (ЄС) 2016/679 (RGPD).
          </Paragraph>
          <Paragraph>
            Зібрані дані обробляються з метою:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>управління професійними обліковими записами;</li>
            <li>виконання договірних зобов'язань;</li>
            <li>поліпшення послуг;</li>
            <li>дотримання законодавчих зобов'язань.</li>
          </ul>
          <Paragraph>
            Повні умови детально викладені в Політиці конфіденційності, доступній на офіційному веб-сайті.
          </Paragraph>

          <Divider />

          <Title level={3}>9. ОБОВ'ЯЗКИ КОРИСТУВАЧА</Title>
          <Paragraph>
            Користувач зобов'язується:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>використовувати Платформу відповідно до її професійного призначення;</li>
            <li>не порушувати права Правовласника або третіх осіб;</li>
            <li>забезпечувати безпеку своїх ідентифікаційних даних;</li>
            <li>негайно повідомляти Правовласника про будь-який шахрайський доступ.</li>
          </ul>
          <Paragraph>
            Будь-яке зловживання може призвести до негайного призупинення надання послуг.
          </Paragraph>

          <Divider />

          <Title level={3}>10. ВІДПОВІДАЛЬНІСТЬ</Title>
          <Paragraph>
            Правовласник не несе відповідальності за:
          </Paragraph>
          <ul style={{ marginBottom: '1em' }}>
            <li>непрямі збитки;</li>
            <li>операційні збитки;</li>
            <li>втрату прибутку;</li>
            <li>шкоду іміджу.</li>
          </ul>
          <Paragraph>
            Загальна відповідальність Правовласника обмежується сумою, фактично сплаченою Користувач протягом останніх дванадцяти (12) місяців.
          </Paragraph>
          <Paragraph>
            Це обмеження не застосовується у разі грубої або умисної вини.
          </Paragraph>

          <Divider />

          <Title level={3}>11. ДОСТУПНІСТЬ</Title>
          <Paragraph>
            Правовласник докладає зусиль для забезпечення розумної доступності Платформи.
          </Paragraph>
          <Paragraph>
            Гарантія безперебійної роботи не надається.
          </Paragraph>

          <Divider />

          <Title level={3}>12. ЗМІНА УМОВ КОРИСТУВАННЯ</Title>
          <Paragraph>
            Правовласник може змінювати ці Умови користування.
          </Paragraph>
          <Paragraph>
            Про будь-які істотні зміни Користувач буде повідомлений у розумний строк.
          </Paragraph>

          <Divider />

          <Title level={3}>13. СТРОК ДІЇ ТА РОЗІРВАННЯ</Title>
          <Paragraph>
            Умови використання застосовуються протягом строку використання ліцензії.
          </Paragraph>
          <Paragraph>
            У разі серйозного порушення Правовласник може призупинити або припинити доступ після безрезультатного попередження.
          </Paragraph>

          <Divider />

          <Title level={3}>14. ПЕРЕДАЧА</Title>
          <Paragraph>
            Правовласник може передати всі або частину своїх прав та обов'язків будь-якій організації своєї групи або в рамках операції з реструктуризації, злиття або поглинання.
          </Paragraph>

          <Divider />

          <Title level={3}>15. ЗАСТОСОВУВАНЕ ПРАВО ТА ЮРИСДИКЦІЯ</Title>
          <Paragraph>
            Ці Умови використання регулюються українським законодавством.
          </Paragraph>
          <Paragraph>
            Будь-який спір щодо їх тлумачення або виконання підпадає под виключну юрисдикцію судів України.
          </Paragraph>

          <Divider />

          <Title level={3}>16. ФОРС-МАЖОР</Title>
          <Paragraph>
            Жодна зі сторін не може бути притягнута до відповідальності за невиконання зобов'язань, що виникло внаслідок форс-мажорних обставин у значенні статті 1218 Цивільного кодексу.
          </Paragraph>

          <Title level={3}>17. ПРИКІНЦЕВІ ПОЛОЖЕННЯ</Title>
          <Paragraph>
            Якщо одне з положень визнано недійсним, інші положення залишаються чинними.
          </Paragraph>

          <Divider />

          <Title level={2}>ДОДАТОК 1 – УГОДА ПРО РІВЕНЬ ОБСЛУГОВУВАННЯ (SLA)</Title>
          <Paragraph>Застосовується до платформи «MusicTMM»</Paragraph>

          <Title level={3}>1. ПРЕДМЕТ</Title>
          <Paragraph>
            Цей додаток визначає зобов'язання щодо рівня обслуговування (Service Level Commitments), що застосовуються до платформи «MusicTMM».
          </Paragraph>
          <Paragraph>У ньому зазначаються:</Paragraph>
          <ul>
            <li>рівні доступності;</li>
            <li>умови підтримки;</li>
            <li>терміни втручання;</li>
            <li>виключення;</li>
            <li>можливі компенсації.</li>
          </ul>

          <Title level={3}>2. ВИЗНАЧЕННЯ</Title>
          <Paragraph>
            <Text strong>Послуга</Text> : доступ до веб-платформи та мобільної платформи, що дозволяє поширювати та керувати музичним контентом у професійному середовищі.
          </Paragraph>
          <Paragraph>
            <Text strong>Інцидент</Text> : несправність, що перешкоджає або значно погіршує нормальне використання Послуги.
          </Paragraph>
          <Paragraph>
            <Text strong>Робочі години</Text> : з понеділка по п'ятницю, з 9:00 до 18:00 (за київським часом), крім святкових днів.
          </Paragraph>

          <Title level={3}>3. ДОСТУПНІСТЬ СЛУЖБИ</Title>
          <Title level={4}>3.1 Зобов'язання щодо доступності</Title>
          <Paragraph>
            Правовласник зобов'язується забезпечити щомісячну доступність Служби на рівні:
          </Paragraph>
          <Paragraph>
            <Text strong>99 % на щомісячній основі</Text>
          </Paragraph>
          <Paragraph>Доступність розраховується наступним чином:</Paragraph>
          <Paragraph italic>
            Доступність (%) = [(Загальний місячний час – Час незапланованої недоступності) / Загальний місячний час] × 100
          </Paragraph>

          <Title level={4}>3.2 Виключення</Title>
          <Paragraph>Не вважаються недоступністю:</Paragraph>
          <ul>
            <li>заплановане технічне обслуговування, про яке повідомлено щонайменше за 24 години;</li>
            <li>випадки форс-мажорних обставин;</li>
            <li>несправність інтернет-мережі Користувача;</li>
            <li>неправильна конфігурація або несправне обладнання Користувача;</li>
            <li>перерва, пов'язана з третьою стороною (хостинг-провайдер, хмарний провайдер тощо).</li>
          </ul>

          <Title level={3}>4. ТЕХНІЧНЕ ОБСЛУГОВУВАННЯ</Title>
          <Paragraph>Правовласник може проводити:</Paragraph>
          <Paragraph>
            <Text strong>Планове технічне обслуговування</Text>
          </Paragraph>
          <ul>
            <li>яке, по можливості, здійснюється поза робочим часом;</li>
            <li>попереднє повідомлення електронною поштою або через платформу.</li>
          </ul>
          <Paragraph>
            <Text strong>Невідкладне технічне обслуговування</Text>
          </Paragraph>
          <ul>
            <li>втручання після виявлення критичної події.</li>
          </ul>

          <Title level={3}>5. ТЕХНІЧНА ПІДТРИМКА</Title>
          <Paragraph>Підтримка доступна через:</Paragraph>
          <ul>
            <li>електронну пошту: Lutsenko@tmm-ukraine.com</li>
            <li>інтерфейс адміністрування</li>
          </ul>

          <Title level={3}>6. РІВНІ ІНЦИДЕНТІВ ТА ТЕРМІНИ ВТРУЧАННЯ</Title>
          <Table 
            columns={slaColumns} 
            dataSource={slaData} 
            pagination={false} 
            bordered 
            size="small"
            scroll={{ x: true }}
          />
          <Paragraph style={{ marginTop: '0.625em' }}>
            Терміни є цілями, а не зобов'язаннями щодо результату.
          </Paragraph>

          <Title level={3}>9. ОБОВ'ЯЗКИ КОРИСТУВАЧА</Title>
          <Paragraph>Користувач зобов'язується:</Paragraph>
          <ul>
            <li>підтримувати стабільне інтернет-з'єднання;</li>
            <li>використовувати сумісне обладнання;</li>
            <li>негайно повідомляти про будь-які інциденти;</li>
            <li>розумно співпрацювати з Правовласником.</li>
          </ul>

          <Title level={3}>10. БЕЗПЕКА</Title>
          <Paragraph>Правовласник вживає розумних технічних та організаційних заходів для забезпечення:</Paragraph>
          <ul>
            <li>безпеки даних;</li>
            <li>захисту від несанкціонованого доступу;</li>
            <li>безперервності діяльності.</li>
          </ul>

          <Title level={3}>11. ЗМІНИ В SLA</Title>
          <Paragraph>
            Правовласник може вносити зміни в цей SLA з метою його адаптації до технологічних або нормативних змін.
          </Paragraph>
          <Paragraph>Про будь-які істотні зміни буде повідомлено заздалегідь.</Paragraph>

          <Title level={3}>12. ВИКЛЮЧЕННЯ НЕПРЯМОЇ ВІДПОВІДАЛЬНОСТІ</Title>
          <Paragraph>
            Правовласник не несе відповідальності за непрямі збитки, операційні збитки або шкоду репутації, що виникли в результаті переривання надання доступу до Платформи.
          </Paragraph>









          <Title level={2}>ДОДАТОК 2 – АВТОРСЬКІ ПРАВА ТА СУМІЖНІ ПРАВА</Title>
          <Paragraph>Зразок прямої ліцензії – MusicTMM</Paragraph>

          <Title level={3}>1. ПРЕДМЕТ</Title>
          <Paragraph>
            Метою цього Додатка є уточнення положень, що застосовуються до авторських прав та подібних прав, пов'язаних з музичним контентом, що поширюється через платформу «MusicTMM ».
          </Paragraph>

          <Title level={3}>2. АВТОРСЬКІ ПРАВА – ПРЯМА ЛІЦЕНЗІЯ</Title>
          <Paragraph>Музичний контент, доступний на Платформі, надається:</Paragraph>
          <ul>
            <li>на підставі володіння майновими авторськими та/або суміжними правами на використання яких безпосередньо належать ТОВ «ТММ-Юкрейн»;</li>
            <li>на підставі наявності права на надання невиключних майнових авторських та/або суміжних прав на використання музичних композицій, що використовуються на підставі прямих ліцензійних угод, укладених з правовласниками.</li>
          </ul>
          <Paragraph>
            За умови дотримання Умов використання та наявності Ліцензійного договору, для поширення творів, що надаються виключно через Платформу, не потрібні жодні додаткові заяви чи платежі на користь організацій колективного управління, чи третіх осіб.
          </Paragraph>

          <Title level={3}>3. ОБМЕЖЕННЯ СФЕРИ ДІЇ</Title>
          <Paragraph>Дія авторських прав, зазначених у статті 2, суворо обмежена:</Paragraph>
          <ul>
            <li>музичними композиціями, фактично наданими Правовласником;</li>
            <li>їх поширенням через Платформу;</li>
            <li>професійним використанням, заявленим Користувачем.</li>
          </ul>
          <Paragraph>
            Будь-яке поширення творів третіх осіб поза Платформою залишається виключною відповідальністю Користувача.
          </Paragraph>

          <Title level={3}>4. СУМІЖНІ ПРАВА – МІЖНАРОДНИЙ РЕЖИМ І СПРАВЕДЛИВА ВИНАГОРОДА</Title>
          <Paragraph>
            Правовласник заявляє, що контролює, безпосередньо або на договірній основі, суміжні права, пов'язані з фонограмами, наданими на Платформі.
          </Paragraph>

          <Title level={3}>5. ГАРАНТІЇ MUSIC TMM</Title>
          <Paragraph>
            Правовласник заявляє, що володіє необхідними правами для надання невиключного права на використання Музичних композицій, включених до Платформи, в рамках прямої ліцензії, описаної в статті 2.
          </Paragraph>
          <Paragraph>
            Правовласник гарантує Користувачу захист від будь-яких дій, заснованих на порушенні авторських прав щодо музичних композицій, наданих через Платформу, за умови:
          </Paragraph>
          <ul>
            <li>суворого дотримання умов Ліцензійного договору;</li>
            <li>відсутності змін, вилучення або несанкціонованого використання вмісту.</li>
          </ul>

          <Title level={3}>6. ЮРИДИЧНА КВАЛІФІКАЦІЯ</Title>
          <Paragraph>Сторони визнають, що Правовласник діє:</Paragraph>
          <ul>
            <li>як постачальник музичного вмісту за прямою ліцензією;</li>
            <li>як оператор платформи SaaS.</li>
          </ul>
          <Paragraph>
            Правовласник не діє як організація колективного управління, а також як оператор закладу, що здійснює публічну трансляцію.
          </Paragraph>

          <Title level={3}>7. ЗМІНИ В РЕГУЛЮВАННІ</Title>
          <Paragraph>
            У разі змін у законодавстві або регулюванні, що впливають на режим, який застосовується до авторських прав або суміжних прав, сторони домовляються добросовісно адаптувати свої договірні відносини.
          </Paragraph>

          <Divider />

          <Title level={2}>ДОДАТОК 3 - ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ</Title>
          <Title level={3}>1. ІДЕНТИФІКАЦІЯ ОСОБИ, ВІДПОВІДАЛЬНОЇ ЗА ОБРОБКУ</Title>
          <Paragraph>
            Правовласник діє виключно в якості відповідального за обробку даних, зібраних в рамках експлуатації веб-платформи та мобільної платформи «MusicTMM».
          </Paragraph>
          <Paragraph>
            Правовласник здійснює виключно B2B-діяльність і не збирає жодних даних, що стосуються кінцевих клієнтів закладів, які використовують Платформу.
          </Paragraph>

          <Title level={3}>2. КАТЕГОРІЇ ОБРОБЛЮВАНИХ ДАНИХ</Title>
          <Title level={4}>2.1 Професійні ідентифікаційні дані</Title>
          <ul>
            <li>робоча електронна адреса</li>
            <li>назва компанії</li>
            <li>ім'я представника</li>
            <li>адреса компанії</li>
            <li>робочий номер телефону</li>
          </ul>
          <Title level={4}>2.2 Технічні дані</Title>
          <ul>
            <li>IP-адреса</li>
            <li>тип і модель пристрою</li>
            <li>операційна система</li>
            <li>журнали входу</li>
            <li>історія використання</li>
          </ul>
          <Title level={4}>2.3 Дані про місцезнаходження</Title>
          <ul>
            <li>приблизне місцезнаходження (країна, місто)</li>
          </ul>
          <Paragraph>Без явного згоди не збираються точні GPS-дані.</Paragraph>
          <Paragraph>Не обробляються чутливі дані в розумінні статті 9 GDPR.</Paragraph>
          <Paragraph>Не здійснюється профілювання та автоматизоване прийняття рішень, що мають юридичні наслідки.</Paragraph>

          <Title level={3}>3. ЦІЛІ ТА ПРАВОВІ ОСНОВИ</Title>
          <Paragraph>Дані обробляються з наступними цілями:</Paragraph>
          <Table 
            columns={privacyColumns} 
            dataSource={privacyData} 
            pagination={false} 
            bordered 
            size="small"
            scroll={{ x: true }}
          />
          <Paragraph style={{ marginTop: '0.9375em' }}>
            Законні інтереси, що переслідуються, включають, зокрема, безпеку Платформи, запобігання шахрайству та постійне поліпшення послуг.
          </Paragraph>
          <Paragraph>
            Коли обробка ґрунтується на законному інтересі, зацікавлена особа може заперечити проти цього з причин, пов'язаних з її особливою ситуацією.
          </Paragraph>

          <Title level={3}>4. ПІДПРИЄМСТВА-ПІДРЯДНИКИ</Title>
          <Paragraph>Деякі дані можуть оброблятися технічними постачальниками, що діють від імені Правовласника, зокрема:</Paragraph>
          <ul>
            <li>хмарні хостинг-провайдери, розташовані в Європейському Союзі;</li>
            <li>технічні постачальники;</li>
            <li>служби технічного обслуговування.</li>
          </ul>
          <Paragraph>Ці постачальники пов'язані договорами, що відповідають статті 28 GDPR.</Paragraph>

          <Title level={3}>5. МІЖНАРОДНІ ПЕРЕДАЧІ</Title>
          <Paragraph>Дані зберігаються в Європейському Союзі.</Paragraph>
          <Paragraph>У разі передачі до третьої країни, вона буде супроводжуватися відповідними гарантіями, зокрема:</Paragraph>
          <ul>
            <li>типовими договірними умовами, прийнятими Європейською Комісією;</li>
            <li>або будь-яким іншим механізмом, визнаним відповідним до GDPR.</li>
          </ul>

          <Title level={3}>6. ТЕРМІН ЗБЕРІГАННЯ</Title>
          <Paragraph>Дані зберігаються:</Paragraph>
          <ul>
            <li>протягом терміну дії договірних відносин;</li>
            <li>потім архівуються відповідно до чинних законодавчих вимог (зокрема, бухгалтерських);</li>
            <li>дані про виставлення рахунків зберігаються протягом десяти (10) років;</li>
            <li>технічні журнали зберігаються протягом максимального терміну дванадцять (12) місяців;</li>
            <li>після цього дані видаляються або анонімізуються.</li>
          </ul>

          <Title level={3}>7. БЕЗПЕКА</Title>
          <Paragraph>Правовласник вживає відповідних технічних та організаційних заходів, зокрема:</Paragraph>
          <ul>
            <li>шифрування даних під час передачі;</li>
            <li>обмежений контроль доступу;</li>
            <li>реєстрація доступу;</li>
            <li>регулярне резервне копіювання.</li>
          </ul>

          <Title level={3}>8. ПРАВА ЗАЦІКАВЛЕНИХ ОСІБ</Title>
          <Paragraph>Відповідно до GDPR, кожна зацікавлена особа має такі права:</Paragraph>
          <ul>
            <li>право на доступ</li>
            <li>право на виправлення</li>
            <li>право на видалення</li>
            <li>право на обмеження</li>
            <li>право на заперечення</li>
            <li>право на перенесення</li>
          </ul>
          <Paragraph>
            Запити можна надсилати на адресу: <Text code>Lutsenko@tmm-ukraine.com</Text>
          </Paragraph>
          <Paragraph>Вони будуть оброблені протягом максимум одного (1) місяця.</Paragraph>

          <Title level={3}>9. ПОРУШЕННЯ ДАНИХ</Title>
          <Paragraph>
            У разі порушення персональних даних, яке може становити ризик для прав і свобод осіб, Правовласник повідомить про це компетентний орган і, у разі необхідності, відповідних осіб відповідно до статей 33 і 34 GDPR.
          </Paragraph>

          <Title level={3}>10. ЗМІНИ</Title>
          <Paragraph>
            Ця Політика може бути оновлена в будь-який час з метою врахування змін у законодавстві або технічних змін.
          </Paragraph>
          <Paragraph>Про будь-які істотні зміни буде повідомлено через Платформу або електронною поштою.</Paragraph>
        </Typography>
    </Layout>
  );
};

export default TermsUA;